import { useModalActions } from 'components/ModalManager/Context';
import { useCallback } from 'react';
import { RechargeModal } from '../AutoRecharge/RechargeModal';

type Props = {
  onSuccess?: (closeModalCb?: () => void) => void;
  onCloseCb?: () => void;
};

const MODAL_ID = 'auto_recharge_dialog';

export const useRechargeModal = ({ onSuccess, onCloseCb }: Props = {}) => {
  const { openModal, closeModal } = useModalActions();

  const onClose = (): void => {
    closeModal({ id: MODAL_ID });
    onCloseCb?.();
  };

  const handleConfirm = useCallback((): void => {
    onSuccess?.();
    closeModal({ id: MODAL_ID });
  }, [onSuccess, closeModal]);

  return useCallback(() => {
    return openModal({
      id: MODAL_ID,
      title: '',
      content: <RechargeModal onConfirm={handleConfirm} onClose={onClose} />,
      makeActions: () => null,
      onClose: () => closeModal({ id: MODAL_ID }),
    });
  }, [openModal, onClose]);
};
